/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { View } from '@az/starc-ui';
import { CMSHeadline } from '../CMSHeadline/CMSHeadline';
import FeaturedCta from './FeaturedCta';
import styles from './SectionTitle.module.scss';

export type SectionTitleProps = {
  title: string;
  ctaText?: string;
  ctaLink?: string;
};

const SectionTitle = ({ title, ctaText, ctaLink }: SectionTitleProps) => {
  return (
    <View className={styles.SectionTitle}>
      <CMSHeadline size="200" noGutter headlineClassName={styles.Title}>
        {title}
      </CMSHeadline>
      <View className={styles.DesktopCta}>
        <FeaturedCta text={ctaText} link={ctaLink} />
      </View>
    </View>
  );
};

export default SectionTitle;
